import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from './Icon';
import { useSearchSuggestionsQuery } from '@services/searchApi';
import { debounce } from '@utils/debounce';
export function SearchBar({ placeholder = '搜索...', onSearch }) {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const inputRef = useRef(null);
    const { data: suggestions = [] } = useSearchSuggestionsQuery(debouncedQuery, {
        skip: debouncedQuery.length < 2,
    });
    // 防抖更新搜索建议
    useEffect(() => {
        const handler = debounce(() => {
            setDebouncedQuery(query);
        }, 300);
        handler();
    }, [query]);
    const handleSearch = (searchQuery) => {
        if (!searchQuery.trim())
            return;
        if (onSearch) {
            onSearch(searchQuery);
        }
        else {
            navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
        }
        setShowSuggestions(false);
        inputRef.current?.blur();
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch(query);
        }
        else if (e.key === 'Escape') {
            setShowSuggestions(false);
        }
    };
    return (_jsxs("div", { className: "relative w-full max-w-md", children: [_jsxs("div", { className: "relative", children: [_jsx("input", { ref: inputRef, type: "text", value: query, onChange: (e) => setQuery(e.target.value), onFocus: () => setShowSuggestions(true), onBlur: () => setTimeout(() => setShowSuggestions(false), 200), onKeyDown: handleKeyDown, placeholder: placeholder, className: "w-full rounded-lg border border-gray-300 py-2 pl-10 pr-4 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500" }), _jsx("div", { className: "pointer-events-none absolute left-3 top-1/2 -translate-y-1/2", children: _jsx(Icon, { name: "search", className: "h-5 w-5 text-gray-400" }) })] }), showSuggestions && suggestions.length > 0 && (_jsx("div", { className: "absolute z-50 mt-2 w-full rounded-lg border border-gray-200 bg-white shadow-lg", children: _jsx("div", { className: "max-h-64 overflow-y-auto", children: suggestions.map((suggestion, index) => (_jsxs("button", { onClick: () => {
                            setQuery(suggestion.text);
                            handleSearch(suggestion.text);
                        }, className: "flex w-full items-center justify-between px-4 py-2 text-left text-sm hover:bg-gray-50", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Icon, { name: "search", className: "h-4 w-4 text-gray-400" }), _jsx("span", { className: "text-gray-900", children: suggestion.text })] }), _jsxs("span", { className: "text-xs text-gray-500", children: [suggestion.count, " \u7ED3\u679C"] })] }, index))) }) }))] }));
}
